// extracted by mini-css-extract-plugin
export default {"tradeContainer":"style_tradeContainer__kRieI","tradeText":"style_tradeText__tKuP4","tradeContent":"style_tradeContent__YZE+R","tradeContentBox":"style_tradeContentBox__Go5+1"};